import { render, staticRenderFns } from "./HeaderV2LogoAtom.vue?vue&type=template&id=353259fe&scoped=true&"
import script from "./HeaderV2LogoAtom.vue?vue&type=script&lang=ts&"
export * from "./HeaderV2LogoAtom.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderV2LogoAtom.vue?vue&type=style&index=0&id=353259fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353259fe",
  null
  
)

export default component.exports